import { Citation, CitationDescription, CitationGrid, CitationIcons, CitationIndex, CitationTitle } from "../components/Citation";
import { Pagination } from "../components/Pagination";
import { cn } from "../lib/utils";
import React, { useState } from "react";
/**
 * A paginated grid of link citations for when an agent answer references many
 * sources, automatically paging through large sets while staying compact for
 * a handful of items. Use it for sizeable, homogeneous link lists; for a few
 * rich, individually composed references use Citation with CitationGrid.
 * @summary Paginated grid of source citations.
 */
export function PaginatedCitationsGrid({
  items,
  maxItemsPerPage = 12
}) {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: maxItemsPerPage
  });
  if (items.length === 0) {
    return null;
  }
  const {
    pageIndex,
    pageSize
  } = pagination;
  const startIndex = pageIndex * pageSize;
  const paginatedItems = items.slice(startIndex, startIndex + pageSize);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex w-full flex-col"
  }, /*#__PURE__*/React.createElement(CitationGrid, null, paginatedItems.map((d, idx) => {
    return /*#__PURE__*/React.createElement(Citation, {
      href: d.href,
      variant: "primary",
      key: idx
    }, /*#__PURE__*/React.createElement(CitationIcons, null, /*#__PURE__*/React.createElement(CitationIndex, null, startIndex + idx + 1), d.icon), /*#__PURE__*/React.createElement(CitationTitle, null, d.title), /*#__PURE__*/React.createElement(CitationDescription, null, d.description));
  })), /*#__PURE__*/React.createElement("div", {
    className: cn("pt-3", items.length > maxItemsPerPage ? "visible" : "collapse")
  }, /*#__PURE__*/React.createElement(Pagination, {
    rowCount: items.length,
    pagination: pagination,
    setPagination: setPagination,
    size: "xs",
    showDetails: false,
    showPageButtons: false
  })));
}
//# sourceMappingURL=PaginatedCitationsGrid.js.map